import { useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import useCheckoutContext from "../store"
import SubmitStepButton from "../user-details/submitStepButton"
import { currency } from "@/lib/helpers/woocommerce"

import Button from "@/common/button/button"
import { useCartContext } from "@/components/woocommerce/cartStore"
import { useMeta } from "@/lib/contexts/appContext"

import MiniCartItem from "@/components/woocommerce/MiniCartItem"
import FormattedMonetaryAmount from "@/components/woocommerce/FormattedMonetaryAmount"
import { trackViewCart } from "@/lib/helpers/tagManager"
import { itemInArrayHasOwn } from "@/lib/helpers/utils"

const GiftShopCheckout = () => {
  const { setNextActiveStep, setStepLoading, setPaymentAmount } =
    useCheckoutContext()
  const { data, isLoading } = useCartContext()
  const { items_count, totals } = data || {}
  const { total_price } = totals || {}
  const { woocommerce } = useMeta()
  const {
    shop_url,
    i18n: {
      minicart: { empty_cart, empty_cart_cta } = {},
      checkout: { total } = {}
    } = {}
  } = woocommerce

  useEffect(() => {
    if (isLoading || !total_price) {
      return
    }

    trackViewCart(data)
    setPaymentAmount(total_price)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total_price])

  useEffect(() => {
    if (!isLoading) {
      setStepLoading(false)
    }

    if (!items_count && isLoading) {
      setStepLoading(true)
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, items_count])

  const methods = useForm({
    mode: "all"
  })

  const onSubmit = () => {
    setPaymentAmount(total_price)
    setNextActiveStep()
  }

  const items = data.items.map((item) => (
    <MiniCartItem key={item.key} item={item} isDisabled={isLoading} />
  ))

  const shipping = data.items.map((item) => {
    if (itemInArrayHasOwn(item.item_data, "is_shipping")) {
      return (
        <dl key={item.key} className="flex items-end justify-between">
          <dt>{item.name}</dt>
          <dd>{item.prices.price} kr</dd>
        </dl>
      )
    }
  })

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        {items_count ? (
          <>
            <ul className="flex flex-col mb-5 border-b border-black-25">
              {items}
            </ul>
            {shipping}
            <dl className="flex items-end justify-between mb-4 text-lg font-bold lg:text-3xl lg:mt-4">
              <dt>{total}</dt>
              <dd>
                <FormattedMonetaryAmount
                  currency={currency}
                  displayType="text"
                  value={total_price}
                />
              </dd>
            </dl>
            <SubmitStepButton />
          </>
        ) : (
          <div className="flex flex-col">
            <p className="mb-4">{empty_cart}</p>
            <Button
              className="flex-grow mx-auto md:flex-grow-0"
              theme="lime"
              type="submit"
              tagName="a"
              ariaLabel={empty_cart_cta}
              href={shop_url ?? "#"}>
              {empty_cart_cta}
            </Button>
          </div>
        )}
      </form>
    </FormProvider>
  )
}

export default GiftShopCheckout
